var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5875 2.9812H13.4125V21.0187H23.5875V2.9812Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1321 12C14.1321 8.38633 15.8406 5.16449 18.5 3.09056C16.5538 1.57279 14.1017 0.668701 11.434 0.668701C5.11984 0.668701 0 5.74256 0 12C0 18.2573 5.11984 23.3312 11.434 23.3312C14.1017 23.3312 16.5566 22.4271 18.5 20.9093C15.8406 18.8354 14.1321 15.6163 14.1321 12Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12C37 18.2573 31.8802 23.3312 25.5661 23.3312C22.8983 23.3312 20.4434 22.4271 18.5 20.9093C21.1594 18.8354 22.8679 15.6163 22.8679 12C22.8679 8.38359 21.1594 5.16449 18.5 3.09056C20.4462 1.57279 22.8983 0.668701 25.5661 0.668701C31.8802 0.668701 37 5.74256 37 12ZM35.908 19.0217V18.6573H36.0573V18.5834H35.6786V18.6573H35.8279V19.0217H35.908ZM36.6406 19.0217V18.5806H36.5245L36.3918 18.882L36.2591 18.5806H36.143V19.0217H36.2259V18.6902L36.3503 18.9751H36.436L36.5604 18.6875V19.019H36.6434L36.6406 19.0217Z",
    fill: "#F37439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.89a0439c1adcc8fb9601b42ec569b309.svg";
export { ForwardRef as ReactComponent };